export const NEW_MESSAGE = 'NEW'
export const REPLY_MESSAGE = 'REPLY'
export const FORWARD_MESSAGE = 'FORWARD'

export const NEW_APPROVE_TEMPLATE = 'APPROVE'
export const NEW_DECLINE_TEMPLATE = 'DECLINE'
export const NEW_DOCS_TEMPLATE = 'DOCS'
export const NEW_CLAIM_PAYMENT_TEMPLATE = 'CLAIM_PAYMENT'
